<template>
  <div>
    <h3 class="title is-4">{{ $t("Synchronisation") }}</h3>
    <form
      @submit.prevent="toggleConfirmationDialog"
      class="db-settings--url-form bottom-space"
    >
      <div class="field">
        <label class="label">
          {{ $t("Server details for synchronisation") }}
        </label>
        <div class="control">
          <input
            class="input db-settings--url-form--url-input"
            type="text"
            v-model="editDbUrl"
            placeholder="https://user:pass@couch.example.com/mydb"
          />
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input
            type="submit"
            :value="$t('Save')"
            class="button is-primary db-settings--url-form--save-button"
          />
        </div>
      </div>
    </form>
    <db-settings-confirm
      v-if="confirmDialogIsVisible"
      :initKeepLocalData="recommendKeepLocalData"
      @userConfirmed="save"
      @userCancelled="toggleConfirmationDialog"
    />

    <form
      v-on:submit.prevent="createAccount"
      class="db-settings--create-account-form bottom-space"
    >
      <div class="field">
        <label class="label">
          {{ $t("Create an account") }}
        </label>
        <div class="control">
          <input
            class="input"
            type="email"
            v-model="requestEmail"
            placeholder="me@example.com"
          />
        </div>
      </div>
      <div class="field">
        <div class="control">
          <input type="submit" :value="$t('Confirm e-mail')" class="button" />
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import Vue from "vue";
import DbSettingsConfirm from "@/components/DbSettingsConfirm";

const strToHex = function (str) {
  var hex = "";
  for (var i = 0; i < str.length; i++) {
    hex += "" + str.charCodeAt(i).toString(16);
  }
  return hex;
};

export default Vue.extend({
  name: "DbSettings",
  components: {
    DbSettingsConfirm,
  },
  data() {
    return {
      editDbUrl: "",
      requestEmail: "",
      confirmDialogIsVisible: false,
    };
  },
  mounted() {
    this.editDbUrl = this.$store.state.dbUrl;
    if (this.$route.query.setAccount && this.$route.query.setSecret) {
      const syncUrl = `https://${this.$route.query.setAccount}:${
        this.$route.query.setSecret
      }@couch.dock.pixelistik.de/userdb-${strToHex(
        this.$route.query.setAccount
      )}`;
      this.editDbUrl = syncUrl;
      this.toggleConfirmationDialog();
    }
  },
  computed: {
    dbUrl() {
      return this.$store.state.dbUrl;
    },
    recommendKeepLocalData() {
      return this.$store.state.dbUrl === "";
    },
  },
  methods: {
    toggleConfirmationDialog: function () {
      this.confirmDialogIsVisible = !this.confirmDialogIsVisible;
    },
    save: function (confirmEvent) {
      this.$router.replace({ query: {} });
      this.$store.dispatch("setDbUrl", {
        url: this.editDbUrl,
        resetLocal: !confirmEvent.keepLocalData,
      });
    },
    createAccount: function () {
      const url = "https://meal-planner-account-service.pixelistik.de/accounts";
      let formData = new FormData();
      formData.append("email", this.requestEmail);

      fetch(url, {
        method: "POST",
        body: formData,
      })
        .then((response) => {
          console.log(response);
          if (response.ok) {
            this.requestEmail = "";
            alert(this.$t("Please check your e-mail for a confirmation link."));
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },
  },
});
</script>

<style scoped>
.bottom-space {
  margin-bottom: 1.5rem;
}
</style>
<i18n>
{
  "en": {},
  "de": {
    "Server details for synchronisation": "Serverdaten für Synchronisation",
    "Create an account": "Account anlegen",
    "Confirm e-mail": "E-Mail bestätigen",
    "Please check your e-mail for a confirmation link.": "Bitte schau in deine E-Mails, du bekommst einen Bestätigungslink."
  }
}
</i18n>
